export default import.meta.ROLLDOWN_FILE_URL_m9opTBgKRGAYPBi8GR2SNA